<template>
	<div class="celloger_nano">
		<PageBanner></PageBanner>
		<div id="title" class="nano_title">
			<span class="nano_eng_title">Celloger Nano</span> 活细胞影像仪
		</div>
		<SectionDivider class="progress" id="title"></SectionDivider>
		<div class="nano_container">
			<img src="../assets/img/index/黄色背景图3.jpg" class="y_img3" />
			<p class="p1">实时活细胞影像仪</p>
			<p class="p2">Celloger Nano</p>
			<p class="p3">Celloger Nano是一款可以无线/有线连接的台式细胞成像仪，<br>
				能够在实验室任意位置观察到细胞的状态。可以用相应的软件功能来观察细胞，<br>
				快速评估细胞的状态。</p>
			<img class="nano_img" src="../assets/img/production/Celloger Nano_2.png" />
		</div>
		<p class="exp3">Celloger Nano是一款可以无线/有线连接的台式细胞成像仪，
			能够在实验室任意位置观察到细胞的状态。可以用相应的软件功能来观察细胞，
			快速评估细胞的状态。</p>
		<div>
			<img src="../assets/img/production/产品中心 条幅3.jpg" class="banner3" />
		</div>
		<div id="title" style="display: flex; align-items: center;margin-top: 7vh;">
			<img src="../assets/img/production/图标1.png" class="icon1" />
			<p style="font-size: 30px; font-weight: 500;margin-left: 10px;">主要特点</p>
		</div>
		<p id="title" style="font-size: 25px;font-weight: bold;margin-top: 3vh;">快速观察细胞状态</p>
		<p id="title" class="subtext" style="text-indent: 2em;">Celloger Nano能够根据实验人员的需求确认不同位置的细胞条件，可以快速有效地观察细胞形态，让实验人员能够快速识别样本的潜在问题。</p>
		<div class="img_container7">
			<img src="../assets/img/production/7.png" class="img_7" />
		</div>
		<p id="title" class="maintext">无线连接适用平板</p>
		<ul id="title" class="subtext">
			<li>无线连接使数据传输更加简单，观察细胞不受距离限制。同时为平板和电脑提供优化的软件，确保无缝的用户体验。</li>
			<li style="margin-top: 20px;">Celloger Nano安装简单，节约时间。</li>
		</ul>
		<div class="img_container8">
			<img src="../assets/img/production/8.png" class="img_8" />
		</div>
		<p id="title" class="maintext">适配多种耗材</p>
		<p id="title" class="subtext" style="text-indent: 2em;">Celloger Nano的载物台能为各种耗材提供足够的空间。</p>
		<div class="img_container91">
			<img src="../assets/img/production/91.png" class="img_91" />
		</div>
		<p id="title" class="maintext">可放置于标准CO2培养箱</p>
		<ul id="title" class="subtext" style="position: relative;line-height: 40px;">
			<li>Celloger Nano设备小巧，尺寸仅为A4纸一半大。相比于其他产品，<br class="br">
				一个标准CO2培养箱可以放置多台Celloger Nano。</li>
			<li style="margin-top: 20px;">在湿热环境下保持设备的性能非常有挑战性，Celloger Nano配备<br class="br">
				的风扇能够防止水汽产生，使其更容易维护，最大限度地降低风险因素。</li>
		</ul>
		<div class="img_container92">
			<img src="../assets/img/production/92.jpg" class="img_92" />
		</div>
		<p id="title" class="maintext text_5">用户友好的功能</p>
		<div class="img_container10">
			<img src="../assets/img/production/11.png" class="img_11" />
			<img src="../assets/img/production/10.png" class="img_10" />
			<p>精确的载物台控制</p>
			<p>预览显示的图像可以随时在Scan App中保存。</p>
		</div>
		<div style="display: flex;justify-content: center;">
			<div class="img_container10_1">
				<img src="../assets/img/production/11.png" class="img_11" />
				<p>精确的载物台控制</p>
				<img src="../assets/img/production/10.png" class="img_10" />
				<p>预览显示的图像可以随时在Scan App中保存。</p>
			</div>
		</div>
		<div id="title" style="display: flex; align-items: center;margin-top: 10vh;">
			<img src="../assets/img/production/图标1.png" style="width: 33px;height: auto;" />
			<p style="font-size: 25px;font-weight: bold;margin-left: 10px;">更多设备信息</p>
		</div>
		<p id="title" class="subtext" style="margin-bottom: 10vh;text-indent: 2em;">想了解更多产品信息请关注下方官网微信公众号、视频号。</p>
	</div>
</template>

<script>
	import PageBanner from '../components/public/PageBanner.vue'
	import SectionDivider from '../components/public/SectionDivider.vue'
	import scrollReveal from '../mixins/scrollReveal'
	export default {
		name: 'CellogerNano',
		components: {
			PageBanner,
			SectionDivider
		},
		mixins: [scrollReveal],
		revealSelectors: ".nano_container, .img_container7, .img_container8, .img_container91, .img_container92, .img_container10"
	}
</script>

<style scoped>
	#title {
		margin-left: calc(50% - 600px);
	}

	.maintext {
		font-size: 30px;
		font-weight: 700;
		margin-top: 10vh;
	}

	.subtext {
		font-size: 18px;
	}

	.nano_title {
		font-size: 1.8em;
		margin-top: 6vh;
		letter-spacing: 1px;
	}

	.nano_eng_title {
		font-family: Rany;
		font-weight: 600;
		font-size: 30px;
	}

	.progress {
		width: 200px;
		margin-top: 10px;
		margin-bottom: 5vh;
	}

	.nano_container {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		transform: translateY(200px);
		transition: transform .5s ease, opacity .5s ease;
		opacity: 0;
	}

	.y_img3 {
		margin-top: 20px;
		height: 450px;
		width: 1200px;
	}

	.nano_img {
		position: absolute;
		width: auto;
		height: 350px;
		margin-left: 680px;
	}

	.nano_container p {
		position: absolute;
	}

	.nano_container .p1 {
		margin-right: 800px;
		margin-bottom: 200px;
		font-size: 28px;
	}

	.nano_container .p2 {
		margin-right: 680px;
		margin-bottom: 100px;
		font-size: 50px;
		font-family: Rany Bold;
		font-weight: 700;
	}

	.nano_container .p3 {
		margin-right: 400px;
		margin-top: 200px;
		font-size: 18px;
		line-height: 2;
	}

	.icon1 {
		width: 33px;
		height: auto;
	}

	.banner3 {
		margin-top: 10vh;
		width: 100%;
	}

	.img_7 {
		width: 1050px;
		height: 550px;
	}

	.img_8 {
		width: 888px;
		height: 333px;
		margin-top: 8vh;
	}

	.img_91 {
		width: 790px;
		height: 430px;
		margin-top: 5vh;
	}

	.img_92 {
		width: 360px;
		height: 335px;
		margin-top: 5vh;
		position: absolute;
		margin-left: 50vw;
		margin-bottom: 20vh;
	}

	.img_10 {
		width: 580px;
		height: 245px;
		margin-top: 3rem;
	}

	.img_11 {
		width: 550px;
		height: 355px;
		margin-top: 3rem;
	}

	.img_container7, .img_container8, .img_container10, .img_container91, .img_container92 {
		display: flex;
		justify-content: center;
		align-items: center;
		transform: translateY(200px);
		transition: transform .5s ease, opacity .5s ease;
		opacity: 0;
	}

	.content-center {
		transform: translateY(0);
		opacity: 1;
	}

	.img_container10 {
		display: grid;
		grid-template-columns: 500px 500px;
		grid-template-rows: 325px;
		text-align: center;
		grid-column-gap: 10rem;
		grid-row-gap: 20px;
	}

	.img_container10_1 {
		display: none;
	}

	.exp3 {
		display: none;
	}

	.text_5 {
		margin-top: 20vh;
	}

	@media screen and (max-width: 1150px) {
		#title {
			margin-left: calc(50% - 450px);
		}

		.y_img3 {
			margin-top: 20px;
			height: auto;
			width: 100%;
		}

		.nano_img {
			position: absolute;
			width: auto;
			height: 250px;
			margin-top: 20px;
		}

		.nano_container .p1 {
			margin-right: 600px;
			font-size: 1.5rem;
		}

		.nano_container .p2 {
			margin-right: 570px;
			font-size: 2rem;
		}

		.nano_container .p3 {
			margin-right: 230px;
			font-size: 1rem;
			margin-top: 150px;
		}

		.img_7 {
			width: 850px;
			height: 450px;
		}

		.img_8 {
			width: 777px;
			height: 275px;
			margin-top: 6vh;
		}

		.img_92 {
			width: 310px;
			height: 285px;
			margin-top: 5vh;
			margin-left: 650px;
		}

		.img_10 {
			width: 480px;
			height: 195px;
			margin-top: 1.5rem;
		}

		.img_11 {
			width: 450px;
			height: 305px;
			margin-top: 1.5rem;
		}
	}

	@media screen and (max-width: 800px) {
		#title {
			margin-left: calc(50% - 180px);
		}

		.maintext {
			font-size: 25px;
		}

		.nano_title {
			font-size: 1.1rem;
			margin-top: 5vh;
		}

		.nano_eng_title {
			font-size: 1.1rem;
			margin-bottom: 5.2rem;
			letter-spacing: 1px;
		}

		.progress {
			width: 120px;
			margin-top: 10px;
		}

		.y_img3 {
			margin-top: 20px;
			height: calc(180px + 10vw);
			width: 100%;
		}

		.nano_container .p1, .nano_container .p2 {
			font-size: 1.2rem;
			margin-right: 200px;
			margin-top: 150px;
		}

		.nano_container .p3 {
			display: none;
		}

		.exp3 {
			display: block;
			margin-right: 30px;
			margin-left: 30px;
			font-size: 1rem;
			line-height: 2;
			text-indent: 2em;
		}

		.nano_img {
			height: 150px;
			width: auto;
			margin-top: 20px;
			margin-left: 200px;
		}

		.banner3 {
			margin-top: 2vh;
			width: 100%;
		}

		.icon1 {
			width: 25px;
			height: auto;
		}

		.img_7, .img_8 {
			width: 380px;
			height: auto;
		}

		.img_91 {
			width: 380px;
			height: 240px;
		}

		.img_92 {
			width: 360px;
			height: 335px;
			margin-top: 5vh;
			position: relative;
			margin-left: 0;
			margin-bottom: 0;
		}

		.img_container10 {
			display: none;
		}

		.img_container10_1 {
			display: grid;
			grid-template-columns: 380px;
			grid-template-rows: 270px;
			text-align: center;
			grid-row-gap: 20px;
		}

		.img_10 {
			width: 380px;
			height: auto;
			margin-top: 1rem;
		}

		.img_11 {
			width: 380px;
			height: auto;
			margin-top: 2rem;
		}

		.subtext {
			margin-right: 20px;
			line-height: 2rem;
		}

		.br {
			display: none;
		}

		.text_5 {
			margin-top: 100px;
		}
	}
</style>